import React, {useCallback} from 'react';
import {BaseTextProps} from './types';
import {useStyle} from '../base/hooks';
import {buildFontStyle} from '../base/functions';

export const BaseText: React.FC<BaseTextProps> = ({
  children,
  textColor,
  align,
  nowrap,
  onPress,
  ...props
}) => {
  const handleClick = useCallback(() => {
    onPress && onPress();
  }, [onPress]);

  const className = useStyle(
    () => ({
      ...(align ? {textAlign: align} : {}),
      ...(textColor ? {color: textColor} : {}),
      ...buildFontStyle(props),
      ...(nowrap ? {whiteSpace: 'nowrap'} : {}),
      ...(onPress ? {cursor: 'pointer'} : {}),
    }),
    [align, textColor, nowrap, props],
  );
  if (onPress) {
    return (
      <a className={className} onClick={handleClick}>
        {children}
      </a>
    );
  }
  return <span className={className}>{children}</span>;
};
